import { Component, Input, OnInit } from 'angular-ts-decorators';

/**
 * Divides the content inside the element in 2 if the text is bigger than the given length.
 * Creates a read more and read less button to show or hide the full text.
 */
@Component({
  selector: 'swReadMore',
  template: require('./sw-read-more.html').default,
})
export class SwReadMoreComponent implements OnInit {
  @Input() text: string;
  @Input() limit: number;

  collapsed: boolean;
  summary: string;

  defaultCharLimit = 140;
  short = false;

  constructor() {
    'ngInject';
  }

  toggle() {
    this.collapsed = !this.collapsed;
  }

  ngOnInit() {
    this.text = this.text || 'lorem ipsum';
    this.collapsed = true;

    let maxLength = !angular.isDefined(this.limit)
      ? this.defaultCharLimit
      : this.limit;

    if (this.text.length > maxLength) {
      this.summary = String(this.text).substring(0, maxLength) + '…';
    } else {
      this.short = true;
      this.collapsed = false;
    }
  }
}
